import React from "react"
function Layout({ children }) {
  return (
    <>
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-P2RGDMS"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
          title="gtag"
        ></iframe>
      </noscript>
      <div id="pageWrapper">{children}</div>
    </>
  )
}

export default Layout
